var hasOwnProperty = Object.prototype.hasOwnProperty;
var Platform = {
  OS: 'unknown',
  Version: 0,
  select: function select(obj) {
    if (hasOwnProperty.call(obj, Platform.OS)) {
      return obj[Platform.OS];
    }

    return obj["default"];
  },
  inject: function inject(platform) {
    Platform['OS'] = platform.OS;
    Platform['Version'] = platform.Version;
  }
};
module.exports = Platform;